import Styled from 'styled-components';
import { Modal as ReactModal } from "react-bootstrap";
import { Modal } from "antd";
const ModalWrapper = Styled(ReactModal)`
.select-address{
    .modal-header{
        border-bottom:none;
    }
}
&.Delete-modal-wrapper-item.modal.show {
    z-index: 11223;
    background: #39393996;
}
&.delete-confirmation-modal .modal-content {
    max-width: 430px;
    margin: auto;
}
&.product-info-modal-wrapper .modal-dialog.modal-dialog-centered {
    max-width: 1012px;
}
&.address-modal-overlay-wrapper .modal-dialog{
    max-width: 664px;
    margin: auto;
}
&.po-details-create-header{
 .modal-title {
    color: #1565D8;
}
}
&.table-ui-modal-wrapper .modal-dialog {
    max-width: 900px;
}
&.restock-add-po-modal .modal-dialog {
    max-width: min(1160px, calc(100vw - 48px));
}
&.inventory-adjustment-modal-wrapper{
  .modal-dialog.modal-md.modal-dialog-centered {
    max-width: 644px;
}
.modal-footer{
  align-items:end;
  justify-content:end !important;
}
}
&.vendor-modal-wrapper-ui .modal-dialog.modal-dialog-centered {
    max-width: 560px;
}
&.delete-confirmation-modal, &.import-expiry-modal {
  z-index: 1000001 !important;
  .modal-footer {
    justify-content: center;
  }
}
&.merge-wo-modal {
  .modal-content {
    max-width: min(560px, calc(100vw - 24px));
    margin: auto;
  }
  .modal-dialog {
    max-height: calc(100vh - 24px);
    display: flex;
    align-items: center;
  }
  .modal-body {
    max-height: calc(100vh - 180px);
    overflow-y: auto;
    padding: 20px !important;
  }
  @media (max-width: 480px) {
    .modal-content { max-width: calc(100vw - 16px); }
    .modal-body { padding: 16px !important; }
  }
}
img.close-modal-icon-custom {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index:2;
    cursor: pointer;
}
&.modal-sku-product-wrapper {
  .modal-dialog{
    max-width: 600px;
}
}
&.add-product-flow {
  .modal-dialog{
    max-width: 808px;
}
button.btn-close {
    color: #fff !important;
    position: relative;
    border-radius: 19px;
    opacity:1;
    background: transparent;
}
.header-padding.modal-header {
    padding: 0px;
}
.modal-body{
  padding: 32px !important;
  h1{
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0;
    margin-bottom: 35px;
    color:${({ theme }) => theme['primary-color']};
  }
}
}
&.confirmation-modal {
    .modal-dialog {
      width: 332px;
    }
    .modal-footer {
      button {
        background-color: ${({ theme }) => theme['primary-color']};
        color: ${({ theme }) => theme['white-color']};
        font-size: 14px;
        font-weight: 700;
        width: 180px;
      }
    }
  }
  &.cogs-modal-full-width .modal-dialog {
    max-width: 75%;
  }
  &.cogs-modal-scroll {
    overflow: hidden !important;
    .modal-dialog {
      max-height: 90vh;
      display: flex;
      flex-direction: column;
      margin: 1.75rem auto;
    }
    .modal-content {
      max-height: 90vh;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      flex: 1;
      min-height: 0;
    }
    .modal-header {
      padding: 14px 20px;
      border-bottom: 1px solid #E8ECF1;
      flex-shrink: 0;
    }
    .modal-body {
      overflow: hidden;
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      padding: 0 !important;
    }
  }
  .btn-close {
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 99;
  }
  .header-padding {
    padding-bottom: 0;
  }
`
export {ModalWrapper}

export const StyledModalWrapper = Styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    background-color: #ffffff;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    padding: 40px 16px 16px;

  }

  .ant-modal-header {
    border-bottom: none;
    background-color: #f0f2f5;
    border-radius: 12px 12px 0 0;
  }

  .ant-modal-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
  }

  .ant-modal-body {
    img.close-modal-icon-custom {
        position: absolute;
        top: 19px;
        right: 15px;
        background: #fff;
        cursor: pointer;
        z-index:1;
    }
  }

  .ant-modal-footer {
    border-top: none;
    padding: 12px 16px;
  }

button.ant-modal-close {
    z-index:2;
    svg{
      color: transparent;
    }
}
footer{
  display: flex;
  place-content: center;
  margin-top: 24px;
  grid-gap:22px;
  button{
    width: 100%;
  }
}
`;
